const base = (state = {}, action) => {
  switch(action.type){
    case 'ADD_BASE':
      return action.data;

    case 'CLEAR_BASE':
      return null;

    default:
      return state;
  }
}

export default base